:host {
  .hide {
    display: none;
  }

  .reporting-tools-partner-logo {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 66px;
    cursor: pointer;

    &:hover {
      transition: all 0.3s;
      background: #f5f5f5;
      background: var(--bg-hover);
    }

    img {
      width: 20px;
      height: 20px;
      object-fit: contain;
      filter: invert(40%) sepia(0%) saturate(2698%) hue-rotate(349deg) brightness(94%) contrast(77%);
      filter: var(--icon-color);
    }
  }

  .reporting-tools-logo {
    position: relative;
    cursor: pointer;
    width: 60px;
    height: 60px;
    background: #afafaf00;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;

    @media screen and (max-width: 1200px) {
      width: 33px;
      height: 66px;
    }

    img {
      &.without-custom-size {
        height: 30px;
        width: 30px;
        padding: 10px;

        @media screen and (max-width: 768px) {
          width: 20px;
          height: 20px;
          padding: 0;
        }
      }

      object-fit: contain;
      // filter: invert(100%) sepia(0%) saturate(7483%) hue-rotate(131deg) brightness(100%) contrast(105%);
      // filter: var(--icon-white);

      @media screen and (max-width: 768px) {
        width: 20px;
        height: 20px;
        padding: 0;
      }

      &:hover {
        animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
      }

      @keyframes shake {
        10%,
        90% {
          transform: translate3d(-1px, 0, 0);
        }

        20%,
        80% {
          transform: translate3d(2px, 0, 0);
        }

        30%,
        50%,
        70% {
          transform: translate3d(-4px, 0, 0);
        }

        40%,
        60% {
          transform: translate3d(4px, 0, 0);
        }
      }
    }
  }

  .onRecording {
    cursor: pointer;
    width: 80px;
    height: 80px;
    padding: 10px;
    background: transparent;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    position: fixed;
    top: 100px;
    right: 10px;

    .record-time {
      position: absolute;
      color: #fff;
      font-weight: 500;
    }

    img {
      width: 80px;
      height: 80px;
      animation: none;

      &:hover {
        animation: none;
        backface-visibility: hidden;
        perspective: 1000px;
      }
    }

    span {
      // width: 15px;
      // height: 15px;
      // border-radius: 50%;
      // background: red;
      // animation: blink-animation 1s steps(3, start) infinite;
      // -webkit-animation: blink-animation 1s steps(3, start) infinite;
    }
  }

  @keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }

  @-webkit-keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }

  app-main-modal {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 10000;
  }

  .recording-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: #fc8878;
    text-align: center;
    line-height: 20px;
    z-index: 10000;
  }
}
